module.exports = __webpack_public_path__ + "img/11.2d10e483.png";